import styled from "styled-components";
import { motion } from "../../../AuthNew/shared/motionUtils";
import { SectionTitle, SectionSubtitle } from "../../shared/onboardingStyles";
import { PrimaryButton } from "../../../AuthNew/shared/authStyles";

const InvitationCardContainer = styled(motion.div)`
  background: ${({ theme }) => theme.colors.main.white};
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
`;

const OrganizationIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme, color }) => color || theme.colors.main.authBlueLight};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.main.authBlue};
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin-top: 24px;
`;

const roleMap = {
  admin: "Admin",
  user: "Team member",
};

const InvitationCard = ({ invitation, onAccept, onDecline }) => {
  return (
    <InvitationCardContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <OrganizationIcon color={invitation?.color}>
        {invitation?.organization_name
          ? invitation.organization_name.charAt(0).toUpperCase()
          : "T"}
      </OrganizationIcon>

      <SectionTitle
        fontSize="20px"
        fontWeight="600"
        margin="0 0 8px 0"
        mobileFontSize="18px"
      >
        {invitation?.organization_name}
      </SectionTitle>

      <SectionSubtitle>
        {roleMap[invitation?.role] || "Team member"}
      </SectionSubtitle>

      <ActionButtonsContainer>
        <PrimaryButton
          width="max-content"
          padding="0 40px"
          onClick={() => onAccept(invitation)}
        >
          Join Team
        </PrimaryButton>
      </ActionButtonsContainer>
    </InvitationCardContainer>
  );
};

export default InvitationCard;
